 

 
    import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // location.state se data nikaalna
  const { type, phone, borrowId } = location.state || {};

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(120); // Timer wapas add kiya h

  // Guard: Agar seedha link se aaye to login bhejo
  useEffect(() => {
    if (!location.state || !phone) {
      navigate("/login", { replace: true });
    }
  }, [location.state, phone, navigate]);

  // Timer logic
  useEffect(() => {
    if (timer === 0) return;
    const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    return () => clearInterval(interval);
  }, [timer]);

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return; // Sirf numbers allow hain
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) document.getElementById(`otp-${index + 1}`)?.focus();
  };

  // const handleVerify = async (e) => {
  //   e.preventDefault();
  //   const finalOtp = otp.join("");

  //   if (finalOtp.length < 6) {
  //     alert("Please enter full 6-digit OTP");
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     // 1. URL decide karna
  //     let url = "";
  //     if (type === "register") {
  //       url = "https://borrowhub-backend.onrender.com/api/auth/verify-register-otp";
  //     } else if (type === "forgot") {
  //       // 🔥 FIX: Forgot password ke liye abhi sirf verify karenge (Backend check zaroori h)
  //       // Iska ek separate verify endpoint hona chahiye ya reset-password me OTP check hoga
  //       // Filhal hum reset-password page par OTP bhej rahe hain verification ke liye
  //       navigate("/reset-password", { state: { phone, otp: finalOtp } });
  //       return; 
  //     } else if (type === "return") {
  //       url = ` https://borrowhub-backend.onrender.com/api/return/verify/${borrowId}`;
  //     }

  //     // 2. API Call
  //     const res = await fetch(url, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ phone, otp: finalOtp }),
  //     });

  //     const data = await res.json();

  //     // 3. Match Logic
  //     if (res.ok && data.success) {
  //       alert("Verification Success!");
  //       if (type === "register") navigate("/login");
  //       if (type === "return") navigate("/return-summary");
  //     } else {
  //       // ❌ Yaha error aayega agar OTP match nahi hua
  //       alert(data.message || "Invalid OTP, please try again.");
  //     }
  //   } catch (err) {
  //     console.error("VERIFY ERROR:", err);
  //     alert("Server Error! Check your connection.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleVerify = async (e) => {
    e.preventDefault();
    const finalOtp = otp.join("");

    if (finalOtp.length < 6) {
      alert("Please enter full 6-digit OTP");
      return;
    }

    setLoading(true);

    try {
      let url = "";
      if (type === "register") {
        url = "https://borrowhub-backend.onrender.com/api/auth/verify-register-otp";
      } else if (type === "forgot") {
        // Forgot password ke liye seedha reset page pe bhejo OTP leke
        navigate("/reset-password", { state: { phone, otp: finalOtp } });
        return; 
      } else if (type === "return") {
        url = `https://borrowhub-backend.onrender.com/api/return/verify/${borrowId}`;
      }

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone, otp: finalOtp }),
      });

      const data = await res.json();

      // 🔥 FIX: data.success wala check hata diya, sirf res.ok kafi hai
      if (res.ok) { 
        alert("Verification Success!");

        if (type === "register") {
          navigate("/login"); // ✅ Ab ye 100% Login page pe le jayega
        } else if (type === "return") {
          navigate("/return-summary");
        }
      } else {
        alert(data.message || "Invalid OTP, please try again.");
      }
    } catch (err) {
      console.error("VERIFY ERROR:", err);
      alert("Server Error! Check your connection.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/auth/resend-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone }),
      });

      const data = await res.json(); // Pehle data parse karna zaroori hai

      if (res.ok) {
        setTimer(120);
        
        // 🔥 FALLBACK CHECK: Agar WhatsApp fail hua, toh naya OTP alert mein dikhega
        if (data.fallbackOtp) {
            alert(`⚠️ Network Issue (WhatsApp)! \nYour NEW OTP is: ${data.fallbackOtp}`);
        } else {
            alert("OTP Resent on WhatsApp!");
        }
      } else {
        alert(data.message || "Failed to resend OTP");
      }
    } catch (err) {
      alert("Error resending OTP");
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center bg-light">
      <div className="card p-4 shadow" style={{ width: 420 }}>
        <h4 className="text-center fw-bold">OTP Verification</h4>
 <p className="text-center text-muted small">OTP sent to: {phone}</p>        
        <form onSubmit={handleVerify}>
          <div className="d-flex justify-content-between my-4">
            {otp.map((digit, index) => (
              <input 
                key={index} 
                id={`otp-${index}`} 
                value={digit} 
                maxLength="1" 
                onChange={(e) => handleChange(e.target.value, index)} 
                className="form-control text-center fs-4" 
                style={{ width: 50, height: 55 }} 
                required
              />
            ))}
          </div>
          
          <button className="btn btn-success w-100" disabled={loading}>
            {loading ? "Verifying..." : "Verify OTP"}
          </button>
        </form>

        <div className="text-center mt-3">
          {timer > 0 ? (
            <span className="text-muted">Resend OTP in {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, "0")}</span>
          ) : (
            <button className="btn btn-link text-success p-0" onClick={handleResend}>Resend OTP</button>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifyOtp;